import React, { useState } from "react";
import { observer } from "mobx-react";
import { toast } from "react-toastify";
import { Button, Modal, Spinner } from "react-bootstrap";

import { useAppStore } from "../../../providers/AppStoreProvider";
import { useAPI } from "../../../providers/ApiProvider";
import { TOASTIFY_OPTIONS } from "../../../config/ReactToastify";

import "./CommentModal.scss";

export const CommentModal = observer(() => {
  const store = useAppStore();
  const api = useAPI();

  const deleteCommentHandler = () => {
    store.commentModal.setSubmitState(true);
    api
      .callApi("deleteComment", { params: { pk: store.commentModal.entityId } })
      .then((res) => {
        store.deleteComment(store.commentModal.entityId);
        store.commentModal.toggle();
        toast.success("Xoá bình luận thành công", TOASTIFY_OPTIONS);
      })
      .catch((e) => {
        console.log(e);
        toast.error("Xảy ra lỗi, không thể xoá bình luận", TOASTIFY_OPTIONS);
      })
      .finally((e) => store.commentModal.setSubmitState(false));
  };

  return (
    <Modal size="md" show={store.commentModal.show} onHide={store.commentModal.toggle} centered>
      <Modal.Header closeButton className="border-0">
        <Modal.Title as="h3" className="fw-bold">
          Xoá bình luận
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <span>Bạn có chắc chắn muốn xoá bình luận này không?</span>
      </Modal.Body>

      <Modal.Footer className="d-flex flex-row justify-content-end border-0">
        <Button
          variant="outline"
          className="text-black-50 rounded-pill border-0 p-2 px-4 me-2"
          onClick={store.commentModal.toggle}
          disabled={store.commentModal.isSubmitting}
        >
          Hủy
        </Button>
        <Button
          className="fw-semibold rounded-pill bg-gradient-orange border-0 p-2 px-4"
          onClick={deleteCommentHandler}
          disabled={store.commentModal.isSubmitting}
        >
          {store.commentModal.isSubmitting && (
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
              className="me-2"
            />
          )}
          Xoá
        </Button>
      </Modal.Footer>
    </Modal>
  );
});
